<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <div class="my-4">
    <page-header class="py-4 pb-6">
      {{ $t('HotPotSettings') }}
      <template #subtitle>
        {{ $t('HotPotSubtitle') }}
      </template>
      <template #action>
        <v-btn
          class="my-2"
          color="amber lighten-4 black--text my-2"
          elevation="0"
          large
          @click="newAdd(0)"
        >
          <div class="text-truncate">
            {{ $t('add') }}
          </div>
        </v-btn>
        <v-btn
          class="amber lighten-4 black--text my-2 ml-2"
          elevation="0"
          large
          outlined
          @click="newAdd(1)"
        >
          <div class="text-truncate">
            {{ $t('AddAll') }}
          </div>
        </v-btn>
      </template>
    </page-header>
    <loading-provider :loading="loading">
      <v-item-group
        v-model="titleGroup"
        class="d-flex flex-wrap mt-4"
        mandatory
      >
        <div
          v-for="item in titleList"
          :key="item.id"
        >
          <v-item
            v-slot="{ active, toggle }"
          >
            <v-btn
              :class="active ? 'amber lighten-4' : ''"
              class="pa-4 mr-4 my-2"
              elevation="0"
              large
              outlined
              @click="toggle"
            >
              <div
                class="d-flex justify-center align-center"
              >
                <div>
                  {{ item._langsname }}
                </div>
                <v-spacer class="px-4" />
                <v-icon
                  v-if="item.isActive === '1'"
                  class="mt-1"
                  @click.stop="changeStatus(item)"
                >
                  mdi-checkbox-outline
                </v-icon>
                <v-icon
                  v-else
                  class="mt-1"
                  @click.stop="changeStatus(item)"
                >
                  mdi-checkbox-blank-outline
                </v-icon>
              </div>
            </v-btn>
          </v-item>
        </div>
      </v-item-group>
      <div
        style="
      display: grid;
      grid-gap: 16px;
      grid-auto-rows:360px ;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr))
"
      >
        <v-card
          v-for="(item,index) in realAttributeList"
          :key="item.id"
          :img="imagePath + item.image"
          class="text-body-1 mt-4"
          elevation="0"
          style="overflow: visible;"
          @click="editItem(item,index)"
        >
          <div
            class="fill-height image-style d-flex flex-column"
            style="border-radius: 16px"
          >
            <div class="d-flex justify-space-between align-center py-4 px-6">
              <div
                class="text-h3 font-weight-bold"
                style="text-shadow: 4px 0px 10px black;color: white"
              >
                {{ item?._langsname }}
              </div>
              <v-menu
                close-on-content-click
                left
                offset-overflow
                offset-y
                rounded
              >
                <template #activator="{on,attrs}">
                  <v-btn
                    dark
                    icon
                    style="border-radius: 12px"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon large>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list
                  outlined
                  width="200px"
                >
                  <v-list-item-group>
                    <v-list-item>
                      <v-list-item-title @click="editItem(item,index)">
                        {{ $t('edit') }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title @click="deleteAttribute(item)">
                        {{ $t('delete') }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-menu>
            </div>
            <v-spacer />
            <div class="py-4 px-4">
              <div style="color: white;text-shadow: 4px 0px 10px black;">
                <div class="d-flex flex-column">
                  <div class="font-weight-bold d-flex">
                    <div>
                      {{ $t('price') }}
                    </div>
                    <v-spacer />
                    <div>
                      {{ item.priceMod |priceDisplay }}
                    </div>
                  </div>
                  <div class="d-flex">
                    <div>
                      {{ $t('tax') }}
                    </div>
                    <v-spacer />
                    <div>
                      {{ item.optdishesCategoryTypeId[0] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </loading-provider>
    <v-dialog
      v-model="editDialog"
      max-width="600px"
    >
      <edit-attribute-dialog
        :add-for-all="addForAll"
        :attribute-group="attributeGroup"
        :dialog-display="editDialog"
        :edit-index="editIndex"
        :edit-item-info="editItemInfo"
        @close="closeDialog"
      />
    </v-dialog>
  </div>
</template>

<script>

import EditAttributeDialog from '@/views/AadenPages/dishes/dish-display/widget/EditAttributeDialog'
import PageHeader from '@/views/widget/typography/PageHeader.vue'
import Attribute from '@/model/dataLayer/api/dish/Attribute'
import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'
import { showSuccessMessage } from '@/model/utils/utils'
import attributeGroup from '@/model/dataLayer/api/dish/AttributeGroup'
import { editAttributeActiveStatus } from '@/model/dataLayer/service/otherService'
import { mapMutations } from 'vuex'
import LoadingProvider from '@/views/widget/LoadingProvider'

export default {
  components: {
    LoadingProvider,
    EditAttributeDialog,
    PageHeader
  },
  data: function () {
    return ({
      loading: false,
      addForAll: 0,
      editIndex: null,
      editItemInfo: null,
      titleGroup: null,
      attributeGroup: null,
      editDialog: false,
      tabTitle: [],
      showAttributeDialog: false,
      activeIndex: null,
      Attribute,
      attributeList: [],
      allAttributeGroupList: []
    })
  },
  computed: {
    entityName () {
      return this.$t('attribute') + (this.currentAttributeGroup ? ' · ' + this.currentAttributeGroup.name : '')
    },
    imagePath () {
      return getRootUrl() + GlobalSettings.dcImageRoot
    },
    titleList () {
      return this.allAttributeGroupList.filter(it => [-1001, -1002, -1003].includes(it.id))
    },
    realAttributeList () {
      return this.attributeList.filter(it => it.attributeGroupId === parseInt(this.titleList[this.titleGroup]?.id))
    }
  },
  watch: {
    titleGroup (val) {
      this.attributeGroup = this.titleList[val]
    },
    editDialog (val) {
      if (!val) {
        this.reload()
      }
    }
  },
  async mounted () {
    await this.reload()
  },
  methods: {
    async deleteAttribute (item) {
      await Attribute.remove(item.id)
      await showSuccessMessage(this.$t('delete_success'))
      await this.reload()
    },
    async reload () {
      this.loading = true
      this.editIndex = -1
      this.allAttributeGroupList = (await attributeGroup.getList(true))
      this.attributeList = (await Attribute.getList(true))
      this.loading = false
    },
    async closeDialog () {
      this.editDialog = false
    },
    newAdd (item) {
      this.addForAll = item === 1 ? 1 : 0
      this.editIndex = -1
      this.editItemInfo = {}
      this.editDialog = true
    },
    editItem (item, index) {
      this.editIndex = index
      if (index !== -1) {
        this.editItemInfo = item
        this.editDialog = true
      }
    },
    ...mapMutations(['showErrorDialog']),
    async changeStatus (item) {
      const res = this.titleList.filter(it => it.isActive === '1')
      if (res.length < 1) {
        item.isActive = item.isActive === '1' ? '0' : '1'
        await editAttributeActiveStatus(item)
        await showSuccessMessage(this.$t('edit_success'))
      } else {
        if (res.length === 1 && item.isActive === '1') {
          this.showErrorDialog('至少保留一个锅底')
        } else {
          item.isActive = item.isActive === '1' ? '0' : '1'
          await editAttributeActiveStatus(item)
          await showSuccessMessage(this.$t('edit_success'))
        }
      }
    }
  }
}
</script>

<style>
.image-style {
  background: rgb(43, 44, 49);
  background: linear-gradient(0deg, rgba(43, 44, 49, 1) 0%, rgba(43, 44, 49, 1) 20%, rgba(43, 44, 49, 0.8) 25%, rgba(43, 44, 49, 0.6) 30%, rgba(43, 44, 49, 0) 50%, rgba(43, 44, 49, 0) 100%);
}
</style>
